import type { ReactNode } from "react";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/shared/components/ui/tooltip";
import { cn } from "@/shared/lib/utils";

type TruncatedHoverTextProps = {
  text: string;
  className?: string;
  children?: ReactNode;
};

export function TruncatedHoverText({
  text,
  className,
  children,
}: TruncatedHoverTextProps) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span tabIndex={0} className={cn("block min-w-0 truncate", className)}>
          {children ?? text}
        </span>
      </TooltipTrigger>
      <TooltipContent className="max-w-96 break-words">{text}</TooltipContent>
    </Tooltip>
  );
}
